module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "combobox",
    class: {
      combobox_desabilitado: _vm.desabilitado,
      combobox_aberto: _vm.aberto
    }
  }, [_c('div', {
    staticClass: "combobox__input",
    on: {
      "mousedown": _vm.aoPressionarNaCaixa
    }
  }, [(_vm.pesquisavel) ? _c('i', {
    staticClass: "far fa-search combobox__icone-busca",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', _vm._b({
    ref: "campo",
    staticClass: "combobox__campo",
    attrs: {
      "type": "text",
      "role": "combobox",
      "autocomplete": "off",
      "readonly": !_vm.pesquisavel,
      "disabled": _vm.desabilitado,
      "aria-expanded": _vm.aberto ? 'true' : 'false',
      "aria-haspopup": "listbox",
      "aria-controls": _vm.idLista,
      "aria-activedescendant": _vm.idOpcaoEmFoco
    },
    domProps: {
      "value": _vm.valorExibidoNoCampo
    },
    on: {
      "focus": _vm.abrir,
      "input": _vm.aoDigitar,
      "keydown": _vm.tratarTeclado
    }
  }, 'input', _vm.$attrs, false)), _vm._v(" "), _c('i', {
    staticClass: "far combobox__icone-seta",
    class: _vm.aberto ? 'fa-chevron-up' : 'fa-chevron-down',
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.aberto) ? _c('ul', {
    staticClass: "combobox__dropdown",
    attrs: {
      "id": _vm.idLista,
      "role": "listbox",
      "aria-multiselectable": _vm.multiplo ? 'true' : 'false'
    }
  }, [(_vm.semResultados) ? _c('li', {
    staticClass: "combobox__sem-resultados"
  }, [_vm._v("\n      Nenhum resultado encontrado\n    ")]) : _vm._l((_vm.opcoesExibidas), function(opcao, indice) {
    return _c('li', {
      key: opcao.semSelecao ? '__sem-selecao__' : opcao.valor,
      staticClass: "combobox__opcao",
      class: {
        combobox__opcao_foco: indice === _vm.indiceEmFoco,
        combobox__opcao_selecionada: _vm.opcaoEstaSelecionada(opcao),
      },
      attrs: {
        "id": _vm.idDaOpcao(indice),
        "role": "option",
        "aria-selected": _vm.opcaoEstaSelecionada(opcao) ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          return _vm.selecionarOpcao(opcao)
        }
      }
    }, [(_vm.multiplo) ? _c('input', {
      staticClass: "combobox__opcao-checkbox",
      attrs: {
        "type": "checkbox",
        "tabindex": "-1"
      },
      domProps: {
        "checked": _vm.opcaoEstaSelecionada(opcao)
      }
    }) : _vm._e(), _vm._v(" "), _vm._t("opcao", function() {
      return [_c('span', {
        staticClass: "combobox__opcao-texto"
      }, [_vm._v(_vm._s(opcao.texto))])]
    }, {
      "opcao": opcao
    })], 2)
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ab1fa356", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab1fa356"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Combobox.vue
// module id = 1139
// module chunks = 1